// extracted by mini-css-extract-plugin
export default {"label":"FieldLabel_label__ZQ2vv"};